import {UPDATE_FILED,AUTH_REST, AUTH_SUCCESS, AUTH_INIT, TOGGLE_DARK_MODE, TOGGLE_SIDE_BAR,SET_DASHBOARD_DATA} from './Actions';

const initialState = {
   user_name: null,
   step: 'INIT',
   remember_token: null,
   darkMode: false,
   loading: false,
   userMeta: null,
   isLogin: false,
   sidebar: false,
   LoadDashboardData:false,
   dashboardData:null,
};

export default (state = initialState, action) => {
   switch (action.type) {
      case AUTH_SUCCESS:
         return {
            ...initialState,
            ...action.payload,
            isLogin: true,
            sidebar: state.sidebar,
            dashboardData: state.dashboardData
         };
      case UPDATE_FILED:
         return {
            ...state,
            [action.payload.prop]: action.payload.value,
         };

      case TOGGLE_DARK_MODE:
         return {
            ...state,
            darkMode: !state.darkMode
         };
      case SET_DASHBOARD_DATA:
         return {
            ...state,
            dashboardData: action.payload
         };
      case TOGGLE_SIDE_BAR:
         return {
            ...state,
            sidebar: !state.sidebar
         };
      case AUTH_INIT:
         return {
            ...initialState,
            ...action.payload,
            dashboardData: state.dashboardData
         };
      case AUTH_REST:
         return initialState;

      default:
         return state;
   }
};
